import { toast } from "react-toastify";
import { api } from "../../../utils/api";
import { uploadImages } from "../../../utils/imageApi";

export async function SupplierCard_importVideo(
  adId: string,
  aliexpressData: any
) {
  const videoUrl = aliexpressData.ae_multimedia_info_dto.ae_video_dtos.ae_video_d_t_o[0].media_url
  const response = await api.get(`/aliexpress/video-proxy?videoUrl=${encodeURIComponent(videoUrl)}`)
  const blob = await response.blob();
  const videoFile = new File([blob], 'video.mp4', { type: 'video/mp4' });
  
  await uploadImages([videoFile], adId, [])
  toast.success('Video téléchargée avec succès');
}